import { FxExtractionWorkflow } from '@mobile-mapping/providers';
import { Component } from 'solid-js';

import { BreaklinesExtractionSettings } from './BreaklinesExtractionSettings';
import { PciExtractionSettings } from './PciExtractionSettings';

export const EXTRACTION_WORKFLOW_SETTINGS: Record<
  FxExtractionWorkflow,
  Component
> = {
  breaklines: BreaklinesExtractionSettings,
  pci: PciExtractionSettings,
};

export function getExtractionWorkflowSettingsComponent(
  workflow: FxExtractionWorkflow | undefined
): Component | undefined {
  if (workflow === undefined) {
    return undefined;
  }

  return EXTRACTION_WORKFLOW_SETTINGS[workflow];
}
